import { updateApplication } from "ee/actions/applicationActions";
import { getThirdPartyAuths } from "ee/selectors/tenantSelectors";
import { App as AntdApp, type ModalProps } from "antd";
import type { ApplicationPayload } from "ce/constants/ReduxActionConstants";
import type { User } from "constants/userConstants";
import { Radio, RadioGroup, Switch } from "design-system";
import { isEmpty } from "lodash";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentUser } from "selectors/usersSelectors";
import { getAppsmithConfigs } from "ee/configs";
const { enableSso } = getAppsmithConfigs();

interface SsoProps extends ModalProps {
  application: ApplicationPayload;
}
const ApplicationSso: React.FC<SsoProps> = ({ application }) => {
  const [selectRadio, SetSelectRadio] = useState<string>("");
  const [switchControl, SetSwitchControl] = useState<boolean>(false);
  const dispatch = useDispatch();
  const socialLoginList = useSelector(getThirdPartyAuths);
  const isCasConnected = socialLoginList.includes("cas");
  const isOidcConnected = socialLoginList.includes("oidc");
  const isDingDingConnected = socialLoginList.includes("dingtalk");
  const isWecomConnected = socialLoginList.includes("wecom");
  
  const onChangeSSO = (val: boolean) => {
    const ssoLoginValue = selectRadio ? { [selectRadio]: val } : {};
    SetSwitchControl(val);
    if (val) {
      dispatch(
        updateApplication(application?.id, {
          ssoLoginConfig: ssoLoginValue,
        }),
      );
    } else {
      dispatch(
        updateApplication(application?.id, {
          ssoLoginConfig: ssoLoginValue,
        }),
      );
    }
  };

  const onChangeRadio = (val: string) => {
    SetSelectRadio(val);
    dispatch(
      updateApplication(application?.id, {
        ssoLoginConfig: {
          [val]: true,
        },
      }),
    );
  };

  // useEffect(() => {
  //   dispatch({
  //     type: ReduxActionTypes.FETCH_ADMIN_SETTINGS,
  //   });
  // }, []);

  useEffect(() => {
    if (!isEmpty(application.ssoLoginConfig)) {
      const fieldNames = Object.keys(application.ssoLoginConfig);
      if (application.ssoLoginConfig[fieldNames[0]]) {
        SetSwitchControl(true);
      }
      SetSelectRadio(fieldNames[0]);
    }
  }, [application.ssoLoginConfig]);
  return (
    <div>
      <div className="px-4">
        <div className="pt-3 pb-2 font-medium text-[color:var(--appsmith-color-black-800)]">
          SSO登录
        </div>
      </div>
      <div className="px-4 pb-4">
        <div className="flex justify-between items-center">
          <Switch
            data-testid={"forking-enabled-toggle"}
            isSelected={switchControl}
            isDisabled={!enableSso}
            onChange={onChangeSSO}
          >
            <div className="text-[0.7rem]">开启后可以选择SSO登录页进行登录</div>
          </Switch>
        </div>
        {switchControl && (
          <RadioGroup
            isDisabled={!enableSso}
            onChange={onChangeRadio}
            value={selectRadio}
          >
            {isCasConnected && <Radio value="CAS">CAS</Radio>}
            {isOidcConnected && <Radio value="OIDC">OIDC</Radio>}
            {isDingDingConnected && <Radio value="DINGTALK">钉钉</Radio>}
            {isWecomConnected && <Radio value="WECOM">企业微信</Radio>}
          </RadioGroup>
        )}
      </div>
      <div
        className={`border-t-[1px] border-[color:var(--appsmith-color-black-300)]`}
      />
    </div>
  );
};

export default ApplicationSso;
